import { LogLevel } from "@azure/msal-browser";

// --- DYNAMIC BASE URL ---
// This automatically gets the base URL, e.g., https://localhost:5173
const BASE_URL = window.location.origin;

// --- IMPORTANT ---
// Replace with your tenant info
const TENANT_SUBDOMAIN = "__VITE_AZURE_AUTHORITY_HOST__";
if (TENANT_SUBDOMAIN.startsWith('__VITE_')) {
  console.warn("Failed to retrieve VITE_AZURE_AUTHORITY_HOST.")
}

const CLIENT_ID = "__VITE_AZURE_CLIENT_ID__";
if (CLIENT_ID.startsWith('__VITE_')) {
  console.warn("Failed to retrieve VITE_AZURE_CLIENT_ID.")
}

// MSAL configuration for Microsoft Entra External ID
export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://${TENANT_SUBDOMAIN}`,
    
    // --- THIS IS THE FIX ---
    // We explicitly tell MSAL to handle the final navigation
    // back to the page the user was on (e.g., /search).
    navigateToLoginRequestUrl: true,

    // Use the dynamic base URL
    redirectUri: BASE_URL,
    postLogoutRedirectUri: BASE_URL,
    knownAuthorities: [TENANT_SUBDOMAIN],
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

// Scopes requested by the application
export const loginRequest = {
  scopes: ["openid", "profile"]
};
